import * as React from "react";
import { Box, Button, TextField } from "@mui/material";
import Image from '../../../ui-components/Image';

export default function FillTheBlank({ question, onAnswer }) {
	const [answer, setAnswer] = React.useState({});

	React.useEffect(() => {
        // reset proceed button
        setAnswer({});
	}, [question]);

	const handleSetAnswer = (i, value) => {
		let ans = {};
		ans[i] = value.trim();
		const newAnswer = { ...answer, ...ans };
		setAnswer(newAnswer);

		let canProceed =
			Object.keys(newAnswer).length === question.totalQuestions;

		onAnswer({
			canProceed,
			answer: newAnswer,
		});
	};

	const createChoices = (choices, choiceName) => {
		return choices.map((choice, i) => (
			<Button
				className="button-choice-paragraph"
				variant={answer[choiceName] === choice ? "contained" : "text"}
				key={`ftb-choice-${i}-${Math.random()}`}
				size="small"
				onClick={() => {
					handleSetAnswer(choiceName, choice);
				}}
			>
				{choice}
			</Button>
		));
	};
	return (
		<React.Fragment>
			<Box
				sx={{
					width: "100%",
					background: "white",
					pb: 2,
					pt: 3,
					px: 1,
					textAlign: "center",
					position: "relative",
				}}
				className="image-container"
			>
				{/* <img
					src={`${publicUrl}/img/questions/${question.questionImage}`}
					style={{
						maxWidth: "100%",
					}}
					draggable="false"
					alt="QuestionImage"
				/> */}
                <Image src={question.questionImage} />
				{question.clipart && (
					<Image
						url={`clipart/${question.clipart}`}
						style={{
							maxWidth: "5rem",
							position: "absolute",
							marginLeft: "-5rem",
						}}
                        skeletonHeight="0"
                        skeletonWidth="0"
						alt="Sale"
					/>
				)}
			</Box>
			<Box
				className="choices-container"
				sx={{ px: 4, textAlign: "center" }}
			>
				{question.questionList.map((qlist, i) => (
					<Box
						className="paragraph"
						key={`ftb-${i}-${Math.random()}`}
					>
						{qlist.map((q, b) => {
							if (q.type === "choices") {
								return createChoices(q.value, q.name);
							} else if (q.type === "textbox") {
								return (
									<TextField
										key={`ftb-input-${i}-${Math.random()}`}
										size="small"
										name={q.name}
                                        defaultValue={answer[q.name] || ''}
										sx={{
											width: "5rem",
											input: {
												textAlign: "center",
												fontSize: "1.2rem",
											},
										}}
										variant="standard"
										onBlur={(e) =>
											handleSetAnswer(
												q.name,
												e.target.value.trim()
											)
										}
									/>
								);
							} else {
								return q.value;
							}
						})}
					</Box>
				))}
			</Box>
		</React.Fragment>
	);
}
